import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { OpportunityListEntitiesResponse } from "lib/generated/integration-api";
import { useIntegrationApi } from "lib/integrationApiContext";

type QueryKey = [string];

export function useListOpportunityEntitiesProvider(
  options?: UseQueryOptions<
    OpportunityListEntitiesResponse | undefined,
    unknown,
    OpportunityListEntitiesResponse,
    QueryKey
  >,
) {
  const api = useIntegrationApi();
  return useQuery(
    ["listOpportunityEntities"],
    async () => {
      const response = await api.opportunityListEntities();
      return response;
    },
    options,
  );
}
